export default "__VITE_ASSET__BKDXMOj9__"